import { render } from "./NavView.vue?vue&type=template&id=10a43cdc&scoped=true&ts=true"
import script from "./NavView.vue?vue&type=script&lang=ts"
export * from "./NavView.vue?vue&type=script&lang=ts"

import "./NavView.vue?vue&type=style&index=0&id=10a43cdc&scoped=true&lang=less"

import exportComponent from "/Users/yong/woolive/webtpl/web/events/uinfo/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a43cdc"]])

export default __exports__